"use client";

import { createContext, useContext, useState } from "react";

type ClientContextType = {
  selectedClientId: string;
  setSelectedClientId: (id: string) => void;
};

const ClientContext = createContext<ClientContextType>({
  selectedClientId: "all",
  setSelectedClientId: () => {},
});

export function ClientProvider({ children }: { children: React.ReactNode }) {
  const [selectedClientId, setSelectedClientId] = useState("all");

  return (
    <ClientContext.Provider value={{ selectedClientId, setSelectedClientId }}>
      {children}
    </ClientContext.Provider>
  );
}

export function useClient() {
  return useContext(ClientContext);
}
